import { Injectable } from '@angular/core';
import { SettingsService } from './settings.service';
import { NetworkConstants } from 'na-lib';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  constructor( private settingsService: SettingsService) { }


  updateProduct(item:any):Promise<void>{
    return new Promise(async (resolve, reject) => {
        
    }) 
    
    
  }

  async createProduct():Promise<string>{
    return new Promise(async (resolve, reject) => {

    })

  }


  deleteProduct(productId):Promise<void>{
    return new Promise(async (resolve, reject) => {

    })
  }
}
